"use client";

import React from 'react';
import { motion } from 'framer-motion';
import Link from 'next/link';
import { Button } from '@/components/ui/button';

export function AboutMission() {
  return (
    <section className="py-24 bg-gradient-to-br from-thistle-100 to-blue-50">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-4xl mx-auto"
        >
          <h2 className="text-h2 mb-6">Unsere Mission</h2>
          <p className="text-body-lg mb-12">
            Wir machen Recruiting wieder zu dem, was es sein sollte: Ein wertschätzender Prozess, der Menschen und Organisationen nachhaltig zusammenbringt. Mit der Kombination aus HR-Expertise und modernster KI-Technologie schaffen wir die Grundlage für eine neue Ära des Recruitings – menschlicher, effizienter und fairer für alle Beteiligten.
          </p>
          <Link href="/contact">
            <Button variant="default">Kontakt aufnehmen</Button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
} 